import { Inbox } from 'lucide-react';

import { ReportsContainer, ReportsEnablingContainer, Header } from 'src/containers/SoftwareEscrow/Reports';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { EscrowPartyTypeEnum, EscrowStatusEnum, InvitationStatusEnum } from 'src/graphql/schema';
import { EmptyBlock } from '@/components/ui/empty-block';
import { cn } from 'src/lib/utils';

const EmptyBlockWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="container mx-auto h-full flex flex-col">
      <Header />
      {children}
    </div>
  );
};

const SoftwareEscrowReports = () => {
  const {
    softwareEscrow: { status, reportsEnabled, beneficiarySharedInformation, currentCompanyRole, escrowInvitation },
  } = useSoftwareEscrow();

  if (status !== EscrowStatusEnum.Active) {
    return (
      <EmptyBlockWrapper>
        <EmptyBlock
          icon={Inbox}
          title="No reports available yet"
          description="Once your escrow is active, you’ll be able to acquire reports by purchasing verification add-ons."
          classes={{
            title: 'text-base',
            card: cn('grow-1 [&>div]:h-full', {
              'opacity-70 pointer-events-none': escrowInvitation?.status === InvitationStatusEnum.Rejected,
            }),
            content: 'h-full flex flex-col justify-center',
          }}
        />
      </EmptyBlockWrapper>
    );
  }

  if (!beneficiarySharedInformation && currentCompanyRole === EscrowPartyTypeEnum.Beneficiary) {
    return (
      <EmptyBlockWrapper>
        <EmptyBlock
          icon={Inbox}
          title="Reports not available"
          description="Reports are available to users with environment visibility. To request access, go to the settings tab in this escrow and Request changes under Technical Information > Notifications settings for beneficiaries and select “Show environment”."
          classes={{
            title: 'text-base',
            card: 'grow-1 [&>div]:h-full',
            content: 'h-full flex flex-col justify-center',
          }}
        />
      </EmptyBlockWrapper>
    );
  }

  if (reportsEnabled) return <ReportsContainer />;

  return (
    <div className="container mx-auto">
      <Header />
      <ReportsEnablingContainer />
    </div>
  );
};

export default SoftwareEscrowReports;
